module.exports = __webpack_public_path__ + "static/media/next-arrow.a91d3827.svg";